import { errorTypes } from "../types/errorTypes";
export const hasValue = _ref => {
  let {
    value,
    required
  } = _ref;
  let error = '';
  if (typeof value === 'string') {
    const trimmed = value.replace(/\s/g, '');
    error = required && !trimmed ? errorTypes.required : '';
  } else {
    error = required && !value ? errorTypes.required : '';
  }
  return error;
};